(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    if (!window.fsVariantSearchInstalled) {
    window.fsVariantSearchInstalled = true;
    const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const pickerFor = (control) => {
      const picker = control.closest('[data-fs-picker-tools]')?.nextElementSibling;
      return picker?.matches('variant-picker.fs-flow-picker') ? picker : null;
    };
    const searchFor = (picker, position) => {
      const tools = picker.previousElementSibling;
      if (!tools?.matches('[data-fs-picker-tools]')) return null;
      return Array.from(tools.querySelectorAll('.fs-option-search')).find((row) => row.dataset.fsOptionPosition === position)?.querySelector('[data-fs-option-search]') ?? null;
    };
    const apply = (fieldset, input) => {
      const labels = Array.from(fieldset.querySelectorAll('.fs-design-scroll > .fs-design-label'));
      const terms = normalize(input?.value ?? '').split(/\s+/).filter(Boolean);
      let visible;
      if (terms.length) {
        visible = labels.filter((label) => terms.every((term) => normalize(label.querySelector('.fs-design-name')?.textContent ?? '').includes(term)));
      } else {
        const limit = Number(fieldset.dataset.fsVisibleLimit) || 9;
        const selected = labels.find((label) => label.querySelector('input:checked'));
        const selectedOutside = selected && labels.indexOf(selected) >= limit;
        visible = labels.slice(0, Math.max(0, limit - (selectedOutside ? 1 : 0)));
        if (selectedOutside) visible.push(selected);
      }
      const shown = new Set(visible);
      labels.forEach((label) => { label.hidden = !shown.has(label); });
      const count = fieldset.querySelector('[data-fs-design-count]');
      if (count) count.textContent = `${visible.length} of ${labels.length} options${terms.length && !visible.length ? ' — try another name or color' : ''}`;
      const more = fieldset.querySelector('[data-fs-option-more]');
      if (more) more.hidden = terms.length > 0 || visible.length >= labels.length;
      const clear = input?.closest('.fs-option-search')?.querySelector('[data-fs-search-clear]');
      if (clear) clear.hidden = !input.value;
    };
    const updateSearch = (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-fs-option-search]')) return;
      const position = input.closest('.fs-option-search')?.dataset.fsOptionPosition;
      const fieldset = Array.from(pickerFor(input)?.querySelectorAll('[data-fs-searchable]') ?? []).find((node) => node.dataset.fsOptionPosition === position);
      if (!fieldset) return;
      fieldset.dataset.fsVisibleLimit = '9';
      apply(fieldset, input);
      const grid = fieldset.querySelector('.fs-design-scroll');
      if (grid) grid.scrollTop = 0;
    };
    document.addEventListener('input', updateSearch);
    document.addEventListener('search', updateSearch);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target instanceof HTMLInputElement && event.target.matches('[data-fs-option-search]')) event.preventDefault();
    });
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const clear = event.target.closest('[data-fs-search-clear]');
      if (clear) {
        const input = clear.closest('.fs-option-search')?.querySelector('[data-fs-option-search]');
        if (input) { input.value = ''; updateSearch({ target: input }); input.focus(); }
        return;
      }
      const more = event.target.closest('[data-fs-option-more]');
      if (!more) return;
      const fieldset = more.closest('[data-fs-searchable]');
      const picker = more.closest('variant-picker.fs-flow-picker');
      if (!fieldset || !picker) return;
      fieldset.dataset.fsVisibleLimit = String((Number(fieldset.dataset.fsVisibleLimit) || 9) + 9);
      apply(fieldset, searchFor(picker, fieldset.dataset.fsOptionPosition));
    });
    document.addEventListener('change', (event) => {
      const radio = event.target;
      if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
      const picker = radio.closest('variant-picker.fs-flow-picker');
      if (!picker) return;
      picker.querySelectorAll('[data-fs-searchable]').forEach((fieldset) => {
        const input = searchFor(picker, fieldset.dataset.fsOptionPosition);
        if (input) input.value = '';
        fieldset.dataset.fsVisibleLimit = '9';
        apply(fieldset, input);
      });
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
